import Http from '../http'

export default {

  index(filter) {
    // let search = ''
    // const {limit, page, level} = filter
    // search = `_page=${page}&_limit=${limit || 1000}&attributes.level=${level}`

    return Http.get(`/documents`, {params: {...filter}})
  },

  createFormData(document){
    let form_data = new FormData();
    const {
      name,
      doc_label_id,
      tag_list,

      company_id,
      project_id,

      file,
    } = document

    form_data.append('document[name]', name)
    if (company_id){
      form_data.append('document[company_id]', company_id)
    }
    if (project_id){
      form_data.append('document[project_id]', project_id)
    }
    if (doc_label_id){
      form_data.append('document[doc_label_id]', doc_label_id)
    }

    for (let i=0; i<tag_list.length; i++) {
      form_data.append(`document[tag_list][]`, tag_list[i]);
    }
    
    if (file){
      form_data.append('document[file]', file);
    }

    document = form_data

    return Http.post(`/documents`, document)
  },
  create(document){
    return Http.post(`/documents`, {document: {
      ...document,
    }})
  },

  updateFormData(part){
    let form_data = new FormData();
    const {
      id,
      name,
      doc_label_id,

      file,
    } = document

    form_data.append('document[name]', name)
    form_data.append('document[doc_label_id]', doc_label_id)
    
    if (file){
      form_data.append('document[file]', file);
    }

    document = form_data

    return Http.put(`/documents/${id}`, document)
  },
  update(document){
    return Http.put(`/documents/${document.id}`, {
      document: {
        ...document,
      },
    });
  },

  show(id) {
    return Http.get(`/documents/${id}`);
  },

  delete(id){
    return Http.delete(`/documents/${id}`)
  }

}
